import { useTranslate } from '@growtherapy/i18n';
import { Body, Label, Tag } from '@growtherapy/sprout-ui';

export function CoachInteractionsTable({
  topics,
  messagesSent,
}: {
  topics: string[];
  messagesSent: number;
}): JSX.Element {
  const t = useTranslate();

  return (
    <div>
      <div className='flex flex-row justify-between'>
        <Label.Small emphasis className='rebrand:font-semibold'>
          {t('telehealth-core:providerIntersessionSummary.coachInteractions')}
        </Label.Small>
        {messagesSent && (
          <Tag use='neutral' size='small'>
            {t('telehealth-core:providerIntersessionSummary.xMessages', { count: messagesSent })}
          </Tag>
        )}
      </div>
      {topics.length ? (
        topics.map((topic, index) => (
          <div key={index} className='flex flex-row justify-between py-2 border-b rebrand:border-border-subtle'>
            <Body.Small className='text-neutral-700 rebrand:text-text-muted'>{topic} </Body.Small>
          </div>
        ))
      ) : (
        <Body.Small className='text-neutral-700 rebrand:text-text-muted'>
          {t('telehealth-core:providerIntersessionSummary.encourageCoachUsage')}
        </Body.Small>
      )}
    </div>
  );
}
